<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 10:25:52
 * @LastEditTime: 2020-07-13 10:40:55
 * @Description: 设置考试时间和考试通过分数
-->
<template>
  <div class="setting-examTime-and-examPassScore">
    <p>
      <span>考试时长：</span>
      <i-input-number
        :value="examTime"
        :readonly="controlDisabled"
        size="small" :min="0" :step="1"
        @on-change="examTimeChangedHandler" />
      <span>&nbsp;&nbsp;分钟</span>
    </p>
    <p>
      <span>总分：</span>
      <span>{{ totalScore }}分</span>
    </p>
    <p>
      <span>及格分数：</span>
      <i-input-number
        :value="examPassScore"
        :readonly="controlDisabled"
        size="small" :min="0" :max="totalScore" :step="1"
        @on-change="examPassScoreChangedHandler" />
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SettingExamTimeAndExamPassScore',
  data() {
    return {
      controlDisabled: false,
      examTime: 0,
      examPassScore: 0,
      totalScore: 0,
    };
  },
  computed: {
    ...mapGetters({
      pageType: 'createPaperStore/pageType',
      questionComplete: 'createPaperStore/questionComplete',
      examTimeForStore: 'createPaperStore/examTime',
      examPassScoreForStore: 'createPaperStore/examPassScore',
    }),
  },
  watch: {
    pageType: {
      immediate: true,
      handler(type) {
        if (type === 'edit') {
          this.controlDisabled = true;
        } else if (type === 'create') {
          this.controlDisabled = false;
        }
      },
    },
    questionComplete: {
      immediate: true,
      handler(data) {
        let totalScore = 0;
        data.forEach((question) => {
          totalScore += question.totalScore;
        });

        this.totalScore = totalScore;
      },
    },
    examTimeForStore(examTime) {
      this.examTime = examTime;
    },
    examPassScoreForStore(examPassScore) {
      this.examPassScore = examPassScore;
    },
  },
  methods: {
    ...mapActions({
      setExamTime: 'createPaperStore/invokeSetExamTime',
      setExamPassScore: 'createPaperStore/invokeSetExamPassScore',
    }),
    /**
     * 考试时间修改
     */
    examTimeChangedHandler(value) {
      this.setExamTime({ examTime: value });
    },
    /**
     * 考试通过分数修改
     */
    examPassScoreChangedHandler(value) {
      this.setExamPassScore({ examPassScore: value });
    },
  },
};
</script>

<style lang="less" scoped>
.setting-examTime-and-examPassScore {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  > p {
    flex: 0 0 calc(100% / 3);
  }

  /deep/ .ivu-input-number {
    width: 56px;
  }
}
</style>
